import { render, staticRenderFns } from "./DocumentNewFormFrGroup.vue?vue&type=template&id=2f8a80b0&"
import script from "./DocumentNewFormFrGroup.vue?vue&type=script&lang=js&"
export * from "./DocumentNewFormFrGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports